import { Check, Lock } from 'lucide-react';
import { designs } from '@/contexts/ThemeContext';

const Preview = ({ design }) => (design === 'modern' ? (
  <div className="h-20 rounded-lg overflow-hidden flex bg-[#f4f6f9] border border-black/5">
    <div className="w-7 bg-[#0f172a] p-1 space-y-1"><div className="h-1.5 rounded bg-[#2563eb]" /><div className="h-1.5 rounded bg-white/20" /><div className="h-1.5 rounded bg-white/20" /></div>
    <div className="flex-1 p-1.5 grid grid-cols-3 gap-1">
      {['#22c55e', '#ef4444', '#f59e0b', '#22c55e', '#3b82f6', '#64748b'].map((c, i) => <div key={i} className="rounded bg-white shadow-sm grid place-items-center"><div className="w-3 h-3 rounded-full" style={{ background: c }} /></div>)}
    </div>
  </div>
) : (
  <div className="h-20 rounded-lg overflow-hidden flex bg-[#fafafa] border border-black/5">
    <div className="w-7 bg-white border-r border-gray-200 p-1 space-y-1"><div className="h-1.5 rounded bg-emerald-500" /><div className="h-1.5 rounded bg-gray-200" /><div className="h-1.5 rounded bg-gray-200" /></div>
    <div className="flex-1 p-1.5 space-y-1"><div className="h-3 w-2/3 rounded bg-gray-300" style={{ fontFamily: 'Fraunces' }} /><div className="h-8 rounded-lg bg-white border border-gray-200" /></div>
  </div>
));

// Elegir Clásico / Moderno
export const DesignPicker = ({ value, onChange, disabled, testid }) => (
  <div className="grid grid-cols-2 gap-3" data-testid={testid}>
    {Object.values(designs).map((d) => {
      const active = value === d.value;
      return (
        <button type="button" key={d.value} disabled={disabled} onClick={() => onChange(d.value)} data-testid={`${testid}-${d.value}`}
          className={`relative p-3 rounded-xl border-2 text-left transition-[border-color,opacity] disabled:opacity-60 disabled:cursor-not-allowed ${active ? 'border-primary ring-2 ring-primary/30' : 'border-border hover:border-primary/50'}`}>
          <Preview design={d.value} />
          <p className="font-semibold text-sm mt-2">{d.name}</p>
          <p className="text-xs text-muted-foreground">{d.description}</p>
          {active && <span className="absolute top-2 right-2 w-5 h-5 bg-primary rounded-full grid place-items-center">{disabled ? <Lock className="w-3 h-3 text-primary-foreground" /> : <Check className="w-3 h-3 text-primary-foreground" />}</span>}
        </button>
      );
    })}
  </div>
);
